import React from 'react'
import { closeLayerFn, openLayerFn } from '../../Layout';

export default(props) => {

  return (
    <div className="blacklayer-container navi-layer">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div className={"blgrn-box vertical"}>
          <div className="blgr-title">송신제한 안내</div>

          <div style={{paddingTop:"15px", color:"#fff", textAlign:"left"}}>
            <p>의료기관의 송신이 제한 되어 있습니다.</p>
            <p>송신이 제한된 경우 다음의 기능 사용이 제한 됩니다.</p>
          </div>

          <div className="save-question-box" style={{padding:"0", textAlign:"left"}}>
            <div style={{paddingTop:"15px"}}>
              <p>{"<제한 기능>"}</p>
              <p>-진료자료(병원공유) 불가</p>
              <p>-기타입력자료(병원공유) 불가</p>
            </div>

            <div style={{paddingTop:"15px"}}>
              자세한 내용은 병원에 확인하세요.
            </div>
          </div>

          <div className="tbns-area" style={{paddingTop:"30px"}}>
            <a className="btn-round wht" id="targetLogout" onClick={()=>closeLayerFn($(".navi-layer"))}>
              확인
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
// 취소/확인 다이얼로그 ]]